const POSTAL_CODE_REGEX = {
    ES: /^\d{5}$/,
    PT: /^\d{4}[-]\d{3}$/,
    DE: /^\d{5}$/,
    NL: /^\d{4}[a-zA-Z]{2}$/
};

module.exports = POSTAL_CODE_REGEX;
